export const allColumns = [
  'transactions',
  'amount',
  'date',
  'status',
];

export const columnLabelFormat = {
  transactions: 'Transactions',
  amount: 'Amount',
  date: 'Date',
  status: 'Status',
};

export const limit = 14;
